export const RATING_ROWS = [
  { id: 1, skill_name: 'PRODUCTIVITY', activeStatus: true },
  { id: 3, skill_name: 'WORK QUALITY', activeStatus: true },
  { id: 4, skill_name: 'COMMUNICATION', activeStatus: true },
  { id: 5, skill_name: 'TEAM COLLABORATION', activeStatus: true },
  { id: 6, skill_name: 'DEADLINE ADHERENCE', activeStatus: true },
];

export const FEEDBACK_FIELDS = [
  {
    key: 'achievements',
    label: 'Key Achievements This Month',
    placeholder: 'Describe your key achievements and accomplishments...',
  },
  {
    key: 'challenges',
    label: 'Challenges Faced',
    placeholder: 'Share any challenges or obstacles you encountered...',
  },
  {
    key: 'suggestions',
    label: 'Suggestions / Improvements',
    placeholder:
      "Provide suggestions for improvement or areas you'd like to develop...",
  },
];

/** Mock summary — replace with API by month */
export const MOCK_SUMMARY = {
  totalHours: 168,
  projects: 5,
  leaves: 2,
  attendancePct: 98,
};

export function createEmptyDraft() {
  return {
    rates: {
      1: 0, // PRODUCTIVITY
      3: 0, // WORK QUALITY
      4: 0, // COMMUNICATION
      5: 0, // TEAM COLLABORATION
      6: 0, // DEADLINE ADHERENCE
    },
    feedback: {
      achievements: '',
      challenges: '',
      suggestions: '',
    },
  };
}

/** Ant Design Form.Item rules for 1–5 star ratings */
export const RATE_FIELD_RULES = [
  {
    validator: (_, val) => {
      const n = Number(val);
      if (!Number.isFinite(n) || n < 1) {
        return Promise.reject(
          new Error('Please rate all categories (at least 1 star each).'),
        );
      }
      return Promise.resolve();
    },
  },
];
